export type TemperatureBand = "cool" | "mild" | "warm" | "hot";

export const BAND_RANGES: Record<TemperatureBand, { min: number; max: number }> = {
  cool: { min: -60, max: 15 },
  mild: { min: 15, max: 22 },
  warm: { min: 22, max: 30 },
  hot: { min: 30, max: 60 },
};

/** Threshold above which a destination gets the "sun" weather icon (= warm band floor). */
export const WARM_THRESHOLD = BAND_RANGES.warm.min;
